export default IconFishBone => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-fish-bone" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M16.69 7.44a6.973 6.973 0 0 0 -1.69 4.56a6.97 6.97 0 0 0 1.699 4.571c1.914 -.684 3.691 -2.183 5.301 -4.565c-1.613 -2.384 -3.394 -3.883 -5.312 -4.565" />
  <path d="M2 9.504a40.73 40.73 0 0 0 2.422 2.504a39.679 39.679 0 0 0 -2.422 2.498" />
  <path d="M18 11v.01" />
  <path d="M4.422 12h10.578" />
  <path d="M7 10v4" />
  <path d="M11 8v8" />
</svg>`;